exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".custom-modal-container {\n  padding: 15px;\n}\n\n.custom-modal-header {\n  background-color: #219161;\n  color: #fff;\n  box-shadow: 0px 3px 5px 0px rgba(0,0,0,0.75);\n  margin-top: -15px;\n  margin-bottom: 40px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/bizisystem-frontend/src/src/app/main/frames/flight-provider-info/flight-provider-info.component.css
// module id = ../../../../../src/app/main/frames/flight-provider-info/flight-provider-info.component.css
// module chunks = main